import { ca } from '@cian/analytics';
import { sendTeaserEvent } from '../../shared/services/teaser';

export function trackAuthPopupShown(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'auth_tab_open',
    label: '',
  });
}

export function forgotPassword(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('Auth_popup', type),
    action: 'auth_tab_click',
    label: 'forgot_password_click',
  });
}

export function successAutorized(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('Authorization', type),
    action: 'auth_popup',
  });
}

export function registrationTab(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'reg_tab_open',
  });
}

export function loginTab(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'auth_tab_open',
  });
}

export function trySendSimpleRegistration(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'reg_tab_click',
    label: 'try_to_send',
  });
}

export function successSimpleRegistration(userType: string, type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('Registration', type),
    action: 'reg_popup',
    label: userType,
  });
}

export function trySendForgotEmail(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'auth_tab_click',
    label: 'try_forgot_password_send',
  });
}

export function successSendForgotEmail(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'auth_tab_click',
    label: 'forgot_password_send',
  });
}

export function cancelForgotEmail(type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('reg_popup', type),
    action: 'auth_tab_click',
    label: 'cancel',
  });
}

export function clickSocialButton(currentTab: string, socialType: string, type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType(currentTab === 'login' ? 'Auth_popup' : 'reg_popup', type),
    action: `${socialType}_click`,
  });
}

export function successSocialAuthOrRegistration(userCreated: boolean, socialType: string, type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType(userCreated ? 'Registration' : 'Authorization', type),
    action: `${socialType}_click`,
    label: userCreated ? 'user' : socialType,
  });
}

export function successMergeEmailSocialAuth(socialType: string, type?: string) {
  ca('event', {
    name: 'oldevent',
    category: getCategoryWithType('Authorization', type),
    action: 'link_accounts',
    label: socialType,
  });
}

function getCategoryWithType(category: string, type: string | undefined) {
  if (type) {
    return type === 'hide' ? `${category}_hideObjects` : `${category}_${type}`;
  }

  return category;
}

export function trackDownloadAppClick(gaLabel: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Mob_menu',
    action: 'download',
    label: gaLabel,
  });
}

export function trackRealtorMenuItemClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    page: {
      ...window?.CianAnalytics?.service.config.page,
      extra: {
        banner_location: 'mob_side_menu',
      },
    },
  });
}

export function trackMortgageMenuItemClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'mortgage_widget',
    action: 'click',
    label: 'adaptive_main_menu_shown',
    page: {
      ...window?.CianAnalytics?.service.config.page,
      extra: {
        banner_location: 'mob_side_menu',
      },
    },
  });
}

export function trackMortgageCalculatorMenuItemClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MortgageCalculator',
    action: 'Click',
    label: 'main_menu_burger',
  });
}

export function trackRealtorMenuItemShown() {
  sendTeaserEvent([
    {
      block_type: 'demand',
      isTeaserShow: true,
      demand_location: 'mob_side_menu',
    },
  ]);
}

export function trackMortgageMenuItemShown() {
  sendTeaserEvent([
    {
      block_type: 'demand',
      name: 'adaptive_main_menu_shown',
      isTeaserShow: true,
      demand_location: 'mob_side_menu',
    },
  ]);
}
